import { useEffect, useRef, useState } from "react";
import axios from "axios";

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,

  Tooltip,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import IconHandaler from "@/components/IconHandaler";
import DataTable from "@/components/DataTable";
import SimpleDailogBox from "@/components/SimpleDailogBox";
import RightViewLayout from "@/components/RighViewLayout";
import LightControl from "./LightControl";
import SearchComponents from "./SearchComponents";



import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";


import { ReactComponent as VisibilityIcon } from "@/assets/images/View_Icon.svg";
import { ReactComponent as EditIcon } from "@/assets/images/Edit_Icon.svg";
import { ReactComponent as DeleteIcon } from "@/assets/images/Delete_Icon.svg";
import { ReactComponent as RefreshIcon } from "@/assets/images/icon_refresh.svg";
import { ReactComponent as AddIcon } from "@/assets/images/Plus_icon.svg";
import { ReactComponent as LightSettings } from "@/assets/images/RGBLightSettings.svg";
import { ReactComponent as UploadIcon } from "@/assets/Icons/Upload Icon.svg";
import { ReactComponent as DownloadIcon } from "@/assets/Icons/Download Icon.svg";

import { deleteProduct, prodcutList } from "@/services/ProductService";

import {
  REACT_PRODUCT,
  REACT_PRODUCT_ADD,
  REACT_PRODUCT_EDIT,
  REACT_PRODUCT_VIEW,
} from "@/router/ReactEndPoints";

export default function Product() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [records, setRecords] = useState([]);
  const [lightOpen, setLightOpen] = useState(false); //  灯光控制
  const [totalRecords, setTotalRecords] = useState(0);
  const [confirm, setConfirm] = useState(false);
  const [id, setId] = useState("");
  const htmlContentRef = useRef();
  const [colums, setColums] = useState([]);
  const permission = JSON.parse(localStorage.getItem("permission"));
  const [allSelectedRows, setAllSelectedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [type, setType] = useState(null)
  const roleName = localStorage.getItem("ROLE_NAME");
  let isAllowedCreate = true;
  let isAllowedView = true;
  let isAllowedEdit = true;
  let isAllowedDelete = true;
  let isAllowedUpload = true;
  let isAlloweddownloadExcel = true;
  let isAllowLight = true
  const [filters, setFilters] = useState({
    pageNumber: 1,
    pageSize: 8,
    name: "",
  });

  const defaultFilters = {
    pageNumber: 1,
    pageSize: 8,
    name: "",
  };



  const loadData = () => {
    prodcutList(filters).then((res) => {
      if (
        res?.data?.code === "LVLI0000" &&
        res?.data?.data &&
        res?.data?.data?.products
      ) {
        setColums(res.data.data?.columns);
        setRecords(res?.data?.data?.products);
        setTotalRecords(res?.data?.data?.totalCount);

      }
    });
  };

  const refreshLoadData = () => {
    setFilters({ ...defaultFilters });

  };

  useEffect(() => {
    loadData();
  }, [filters]);

  const ImagePopUp = () => {
    return (
      <div
        id="htmlContent"
        ref={htmlContentRef}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}></div>
    );
  };

  if (roleName === "ADMIN") {
    isAllowedCreate = permission && permission.some((x) => x === "AddProduct");
    isAllowedView = permission && permission.includes("ViewProduct");
    isAllowedEdit = permission && permission.includes("EditProduct");
    isAllowedDelete = permission && permission.includes("DeleteProduct");
    isAllowedUpload = permission && permission.includes("UploadProduct");
    isAllowLight = permission && permission.includes("ProductLightSetting");

    isAlloweddownloadExcel =
      permission && permission.includes("DownloadProduct");
  }

  const [columns, setColumns] = useState([]);
  useEffect(() => {
    const response = colums?.map((item) => {
      return {
        headerName: item?.label,
        field: item?.name,
        flex: 1,
        headerAlign: "center",
        align: "center",
      };
    });

    let data = response.slice(0, 5);
    data.push({
      headerName: `${t("common.actions")}`,
      headerAlign: "center",
      align: "center",
      renderCell: (e) => (
        <IconHandaler>
          {isAllowedView && (
            <Tooltip id="Product-button-12" title={t("common.view")} arrow>
              <VisibilityIcon
                onClick={() => handleActions("View", e.row.id)}
                style={{
                  alignSelf: "center",
                  paddingTop: "0px",
                  cursor: "pointer",
                  opacity: "0.6",
                  height: "17px",
                  width: "20px",
                  padding: "2px",
                }}
              />
            </Tooltip>
          )}
          {isAllowedEdit && (
            <Tooltip title={t("common.edit")} sx={{ marginLeft: 1 }}>
              <EditIcon
                onClick={() => handleActions("Edit", e.row.id)}
                style={{
                  alignSelf: "center",
                  paddingTop: "0px",
                  cursor: "pointer",
                  opacity: "0.6",
                  height: "17px",
                  width: "20px",
                  padding: "2px",
                }}
              />
            </Tooltip>
          )}
          {isAllowedDelete && (
            <Tooltip
              id="Product-button-13"
              title={t("common.delete")}
              sx={{ marginLeft: 1 }}>
              <DeleteIcon
                onClick={() => handleActions("Delete", e.row.id)}
                style={{
                  alignSelf: "center",
                  paddingTop: "0px",
                  cursor: "pointer",
                  opacity: "0.6",
                  height: "17px",
                  width: "20px",
                  padding: "2px",
                }}
              />
            </Tooltip>
          )}
        </IconHandaler>
      ),
    });

    setColumns(data);
  }, [colums]);

  const handleActions = (action, data) => {
    if (action === "View") {
      const id = data;
      navigate(REACT_PRODUCT_VIEW, { state: { id } });
    }
    if (action === "Edit") {
      const id = data;
      navigate(REACT_PRODUCT_EDIT, { state: { id } });
    }
    if (action === "Delete") {
      // handleDelete(data);
      setId(data);
      setConfirm(true);
    }
  };

  const handleDelete = (id) => {
    deleteProduct(id).then((res) => {
      if (res?.data?.code === "LVLI0002") {
        enqueueSnackbar(t("tips_product.product_deleted_success"), {
          variant: "success",
        });
        setConfirm(false);
        loadData();
        navigate(REACT_PRODUCT);
      }
      if (res?.data?.code !== "LVLI0002") {
        enqueueSnackbar(res.data.message, { variant: "error" });
        setConfirm(false);
      }
    });
  };

  const handlePageChange = (e) => {
    setAllSelectedRows(removeDuplicate([...allSelectedRows, ...selectedRows]));

    const newFilters = {
      ...filters,
      pageNumber: e + 1,
    };

    setFilters(newFilters);

  };

  const handlePageSize = (e) => {
    setAllSelectedRows(removeDuplicate([...allSelectedRows, ...selectedRows]));
    const newFilters = {
      ...filters,
      pageSize: e,
    };

    setFilters(newFilters);

  };

  const [excelFile, setExcelFile] = useState(null);
  const [filePayload, setFilePayload] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setConfirm(false);
  };

  const handleFileUpload = () => {
    if (!excelFile) {
      enqueueSnackbar("Please Choose A File!", { variant: "error" });
      return;
    }
    var bodyFormData = new FormData();
    bodyFormData.append("file", excelFile);
    setUploadProgress(0);
    axios({
      method: "post",
      url: process.env.REACT_APP_SERVER_URL + "/web/product/excel",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("USER_TOKEN"),
        selectedClient: localStorage.getItem("RETAIL_CLIENT"),
        "accept-language": localStorage.getItem("RC_LANG_KEY"),
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadProgress(percentCompleted);
      },
    })
      .then((res) => {
        if (res?.data?.code === "LVLI0008") {
          enqueueSnackbar(t("tips_product.product_created_success"), {
            variant: "success",
          });
          setOpen(false);
          setFilePayload(null);
          loadData();
        } else {
          setUploadProgress(0);
          enqueueSnackbar(res?.data?.message, { variant: "error" });
        }
      })
      .finally(() => {
        setUploadProgress(0);
      });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedExtensions = [".xlsx", ".xls"];
      const fileNameParts = selectedFile.name.split(".");
      const fileExtension =
        fileNameParts.length > 1 ? fileNameParts.pop().toLowerCase() : "";

      if (allowedExtensions.includes(`.${fileExtension}`)) {
        setExcelFile(selectedFile);
        setFilePayload(selectedFile.name);
      } else {
        enqueueSnackbar(t("tips_product.accept_excel_format"), {
          variant: "error",
        });
        e.target.value = null;
      }
    }
  };

  //Download data in excel format
  const downloadExcel = async () => {
    let clientId = localStorage.getItem("RETAIL_CLIENT");
    try {
      axios({
        method: "get",
        url: process.env.REACT_APP_SERVER_URL + "/web/products/download/excel",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("USER_TOKEN"),
          "accept-language": localStorage.getItem("RC_LANG_KEY"),
          selectedClient: clientId,
        },
        responseType: "blob",
      })
        .then((response) => response.data)
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = blobUrl;
          a.download = t("menu.product") + ".xls";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  useEffect(() => {
    if (!open) {
      setExcelFile(null);
      setFilePayload(null);
    }
  }, [open]);

  const handleCancel = () => {
    setOpen(false);
  };

  // Popup to upload data from excel file
  const UploadPopup = () => {
    return (
      <Card
        style={{
          width: "100%",
          height: "100%",
        }}>
        <CardContent>
          <Grid>
            <Typography>{t("tips_product.choose_excel_file")}</Typography>
          </Grid>
          <Grid
            pt={1}
            display={"flex"}
            border={"1px solid #ccc"}
            borderRadius={"10px"}
            justifyItems={"center"}
            alignItems={"center"}
            height={"55px"}>
            {/* <FormControl fullWidth>
              <InputLabel htmlFor="excelFile">Upload File</InputLabel>
              <TextField
                id="excelFile"
                name="excelFile"
                type="file"
                accept=".xls, .xlsx"
                sx={{
                  display: "none",
                }}
                onChange={handleFileChange}
                inputProps={{ "aria-label": "Upload File" }} // 用于辅助工具的文本
              />
            </FormControl> */}

            <div style={{ marginTop: "-10px", marginLeft: "15px" }}>
              <input
                accept=".xls, .xlsx"
                style={{ display: "none" }}
                id="excel-file-upload"
                type="file"
                onChange={handleFileChange}
              />
              <label htmlFor="excel-file-upload">
                <Button variant="contained" component="span">
                  {t("tips_gateway.uploadFile")}
                </Button>
              </label>
            </div>
            {filePayload ? (
              <Typography
                variant="body1"
                style={{ marginTop: "8px", marginLeft: "10px" }}>
                {filePayload}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                style={{ marginTop: "0px", marginLeft: "10px" }}>
                {t("tips_gateway.upload_excel_file")}
              </Typography>
            )}
          </Grid>
          <Grid justifyContent={"center"} container>
            {uploadProgress > 0 && <CircularProgress />}
          </Grid>
          <Grid>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("product.serial_number")}</TableCell>
                  <TableCell>{t("table.name")}</TableCell>
                  <TableCell>{t("product.category_level1")}</TableCell>
                  <TableCell>{t("product.category_level2")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{t("product.number_one")}</TableCell>
                  <TableCell>{t("product.coca_cola")}</TableCell>
                  <TableCell>{t("product.drink")}</TableCell>
                  <TableCell>{t("product.cold_drink")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{t("product.number_two")}</TableCell>
                  <TableCell>{t("product.coca_cola")}</TableCell>
                  <TableCell>{t("product.drink")}</TableCell>
                  <TableCell>{t("product.cold_drink")}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Typography pt={1}>
              {t("tips_product.note_excel_format")}
            </Typography>
          </Grid>
          <Grid container justifyContent={"flex-end"} pt={2}>
            <Box pr={1}>
              <Button
                id="Product-button-01"
                variant="outlined"
                onClick={handleCancel}
                style={{ borderRadius: "8px" }}>
                {t("common.cancel")}
              </Button>
            </Box>
            <Box>
              <Button
                id="Product-button-02"
                variant="contained"
                style={{
                  size: "medium",
                  borderRadius: "8px",
                  opacity: 1,
                  background:
                    "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat padding-box",
                }}
                onClick={handleFileUpload}>
                {t("common.upload")}
              </Button>
            </Box>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const removeDuplicate = (arr) => {
    let key = [];
    let temp = arr.filter((item, index) => {
      let id = Object.keys(item)[0];
      if (key.indexOf(id) < 0) {
        key.push(id);
        return true;
      } else {
        return false;
      }
    });
    return temp;
  };


  const handleSelection = (ids) => {


    const updatedSelectedRows = [];
    const selectedResolution = [];
    let pageIds = records.map((item) => {
      return item.id;
    });
    let newTemp = allSelectedRows.filter((item) => {
      let id = Object.keys(item)[0];
      if (pageIds.indexOf(id) < 0) {
        return true;
      } else {
        return false;
      }
    });
    ids.forEach((id) => {
      const record = records.find((row) => row.id === id);
      if (record) {
        updatedSelectedRows.push({ [id]: record.id });
        selectedResolution.push(record.id);
      }
    });

    let temp = removeDuplicate([...newTemp, ...updatedSelectedRows]);



    setAllSelectedRows(temp);
    setSelectedRows(ids);
  };




  const ButtonStyles = {
    height: "45px",
    width: "45px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
    marginRight: 2,
    background: "#fff",
  };



  const handleSearch = (values) => {
    const newFilters = {
      pageNumber: defaultFilters.pageNumber,
      ...filters,
      ...values,
    };

    setFilters(newFilters);

  };

  return (
    <RightViewLayout
      title={t("product.product")}
      globalFilterProps={false}
    >

      <Grid
        container
        sx={{
          border: "1px solidrgba(124, 106, 106, 0.09)",
          padding: "25px",
          height: "95px",
          background: `#FFFFFF 0% 0% no-repeat padding-box`,
          boxShadow: `0px 1px 3px #0000001A`,
          borderRadius: "8px"
        }}

      >
        <SearchComponents onSearch={handleSearch}></SearchComponents>
      </Grid>

      <Grid
        container
        xs={12}
        sx={{ display: "flex", justifyContent: 'flex-end', marginBottom: "30px", marginTop: "30px" }}>
        {isAllowLight && <Tooltip title={t("common.light_setting")}>
          <Grid item id="Product-button-05" sx={ButtonStyles}>
            <LightSettings
              onClick={() => {
                if (selectedRows && selectedRows.length > 0) {
                  setLightOpen(true);
                  setType("product")
                } else {
                  enqueueSnackbar(t("product.select_product"), {
                    variant: "error"
                  })
                }

              }}
            />
          </Grid>
        </Tooltip>}


        {isAlloweddownloadExcel && (
          <Tooltip title={t("tips_product.download_excel_format")}>
            <Grid id="Product-button-03" item sx={ButtonStyles}>
              <DownloadIcon onClick={downloadExcel} />
            </Grid>
          </Tooltip>
        )}

        {isAllowedUpload && (
          <Tooltip title={t("tips_gateway.uploadFile")}>
            <Grid item id="Product-button-04" sx={ButtonStyles}>
              <UploadIcon onClick={() => setOpen(true)} />
            </Grid>
          </Tooltip>
        )}



        <Tooltip title={t("common.refresh")}>
          <Grid item id="Product-button-05" sx={ButtonStyles}>
            <RefreshIcon onClick={() => refreshLoadData()} />
          </Grid>
        </Tooltip>

        {isAllowedCreate && (
          <Tooltip title={t("product.add_product")}>
            <Grid item id="Product-button-06" sx={ButtonStyles}>
              <AddIcon
                sx={{ color: "white" }}
                onClick={() => navigate(REACT_PRODUCT_ADD)}
              />
            </Grid>
          </Tooltip>
        )}
      </Grid>


      <DataTable
        columns={columns}
        rows={records}
        page={filters.pageNumber - 1}
        totalRecords={totalRecords}
        rowsPerPage={filters.pageSize}
        onPageChange={(pn) => handlePageChange(pn)}
        onPageSizeChange={(ps) => handlePageSize(ps)}
        onSelection={(id) => handleSelection(id)}
        rowSelectionModel={allSelectedRows.map((item) => {
          return Object.keys(item)[0];
        })}

        checkboxSelection={true}
        disableRowSelectionOnClick={true}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        style={{ backdropFilter: "blur(5px)" }}>
        <DialogContent>
          <ImagePopUp />
        </DialogContent>
      </Dialog>

      <Dialog open={confirm} onClose={handleClose} maxWidth="md">
        <DialogTitle>
          <Typography variant="subtitle2">
            {t("tips_product.product_delete_confirmation")}
          </Typography>
          <Typography sx={{ textAlign: "center" }} variant="subtitle2">
            {t("tips.selected_delete_record")}
          </Typography>
        </DialogTitle>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          padding={"10px"}
          justifyContent={"center"}>
          <Box display="flex" justifyContent="center">
            <Button
              variant="outlined"
              color="primary"
              style={{ fontSize: "normal normal normal 14px / 22px Roboto" }}
              onClick={handleClose}
              sx={{ marginRight: 2 }}>
              {t("common.cancel")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                background:
                  "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%)",
                color: "#FFFFFF",
                fontSize: "normal normal normal 14px / 22px Roboto",
                width: "80px",
              }}
              onClick={() => handleDelete(id)}>
              {t("common.delete")}
            </Button>
          </Box>
        </Grid>
      </Dialog>

      <SimpleDailogBox
        width={"300"}
        open={open}
        onClose={handleClose}
        backdropFilter="blur(5px)">
        <UploadPopup />
      </SimpleDailogBox>

      <LightControl type={type} selectedRows={selectedRows} open={lightOpen} setOpen={setLightOpen}></LightControl>
    </RightViewLayout >
  );
}
